// extracted by mini-css-extract-plugin
export default {"efficiency":"Efficiency_efficiency__Di6t0","content":"Efficiency_content__BDz7M"};